import React from "react";
import Navbar from "../Components/Navbar";
import {Helmet} from "react-helmet";
// import '../Styles/AccountTypeSelection.scss';

function Store() {
   return (
      <div>
         <Helmet>
            <title>Store - Camp Connect</title>
         </Helmet>
         <Navbar/>
         <br></br>
         <br></br>
         <br></br>
         <h1>This will be the future Store information page</h1>
      </div>
   )
};

export default Store;
